import { ACTION_TYPES } from './globalSlice'

export const toggleConnectWalletModal = (_value) => (dispatch) => {
  dispatch({
    type: ACTION_TYPES.toggleConnectWalletModal,
    payload: _value,
  })
}
